import * as moment from 'moment';
import { TimeUnit, IFrequency } from '../../models';

export function toDuration(freq: IFrequency): moment.Duration {
    const timeUnitLabel = getUnitLabel(freq);
    const duration = moment.duration(freq.interval, timeUnitLabel as any);
    return duration;
}

export function getUnitLabel(freq: IFrequency):string{
    let timeUnitLabel: string;

    switch (freq.intervalTimeUnit) {
        case TimeUnit.Second:
            timeUnitLabel = 's';
            break;
        case TimeUnit.Minute:
            timeUnitLabel = 'm';
            break;
        case TimeUnit.Hour:
            timeUnitLabel = 'h';
            break;
        case TimeUnit.Day:
            timeUnitLabel = 'd';
            break;
        case TimeUnit.Week:
            timeUnitLabel = 'w';
            break;
        case TimeUnit.Month:
            timeUnitLabel = 'M';
            break;
        case TimeUnit.Year:
            timeUnitLabel = 'y';
            break;
        default:
            timeUnitLabel = '';
            break;
    }
    return timeUnitLabel;
}